import { useCallback, useState } from 'react';

export const useSoftwareExpansion = () => {
  const [showAll, setShowAll] = useState(false);
  const toggle = useCallback(() => setShowAll((prev) => !prev), []);
  return { showAll, toggle };
};
